import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-best-saller';
import buttonPrimary from '../../ui-modules/button-primary/raw-html';

const btnPrimary = buttonPrimary({
  align: 'center',
  text: 'View All',
  policy: {
    show: false,
    colPerView: 2,
    alignContent: 'center',
    items: [],
  },
  backgroundColor: '#AD4870',
  radius: 50,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f67b652406680e147e0b.png',
  },
});

const products = [
  {
    link: '#',
    title: '<h3>3D Anti-Cellulite & Lifting Legging</h3>',
    state: { show: true, text: 'New' },
    price: '$19.90',
    oldPrice: '$39.90',
    images: [
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f50d8edb00ad606e2716.png',
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f511457577bc43822a0c.png',
    ],
  },
  {
    link: '#',
    title: '<h3>3D Anti-Cellulite & Lifting Legging...</h3>',
    state: { show: false, text: 'New' },
    price: '$19.90',
    oldPrice: '$39.90',
    images: [
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f514469a6306eef64884.png',
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f5176f91689cfefb67fd.png',
    ],
  },
  {
    link: '#',
    title: '<h3>3D Anti-Cellulite & Lifting Legging...</h3>',
    state: { show: false, text: 'New' },
    price: '$19.90',
    oldPrice: '$39.90',
    images: [
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f5197ec000a37580b5e8.png',
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f51c0203519d33d31e89.png',
    ],
  },
  {
    link: '#',
    title: '<h3>3D Anti-Cellulite & Lifting Legging...</h3>',
    state: { show: false, text: 'New' },
    price: '$19.90',
    oldPrice: '$39.90',
    images: [
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f520ed5527e61dc7c817.png',
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f525526d96b0f5d8201e.png',
    ],
  },
  {
    link: '#',
    title: '<h3>3D Anti-Cellulite & Lifting Legging...</h3>',
    state: { show: false, text: 'New' },
    price: '$19.90',
    oldPrice: '$39.90',
    images: [
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f5290f9a2cb208d3cde5.png',
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f52d9958dad851e9e7b5.png',
    ],
  },
  {
    link: '#',
    title: '<h3>3D Anti-Cellulite & Lifting Legging...</h3>',
    state: { show: false, text: 'New' },
    price: '$19.90',
    oldPrice: '$39.90',
    images: [
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f5302ce93602d7acff2d.png',
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f5334699bbf44a9b03b3.png',
    ],
  },
  {
    link: '#',
    title: '<h3>3D Anti-Cellulite & Lifting Legging...</h3>',
    state: { show: false, text: 'New' },
    price: '$19.90',
    oldPrice: '$39.90',
    images: [
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f5373c76e6512e144f9e.png',
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f53a3eb68580ca3f9f95.png',
    ],
  },
  {
    link: '#',
    title: '<h3>3D Anti-Cellulite & Lifting Legging...</h3>',
    state: { show: false, text: 'New' },
    price: '$19.90',
    oldPrice: '$39.90',
    images: [
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f53defbc905da48191d2.png',
      'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f53f681affed91bbce55.png',
    ],
  },
];

const renderProductItem = item => {
  const showState = item.state?.show !== false;
  return `
  <a href="${item.link || '#'}" data-attribute="item-product" class="item-product">
    <div class="group-images">
      <div class="wrap-images" data-attribute="wrap-images">
        ${item.images.map(image => `<img data-attribute="item-image" src="${image}" alt="" />`).join('')}
      </div>
      <div
        class="state"
        data-attribute="state"
        data-show="${showState ? 'true' : 'false'}"
        style="display: ${showState ? '' : 'none'};"
      >
        ${item.state?.text || ''}
      </div>
    </div>
    <div class="item-info" data-attribute="item-info">
      <div class="title-item" data-attribute="title-item">
        ${item.title}
      </div>
      <div class="block-price-cart">
        <div class="block-price">
          <span data-attribute="price" class="price">${item.price}</span>
          <span data-attribute="old-price" class="old-price">${item.oldPrice}</span>
        </div>
        <div class="block-view-cart">
          <div class="view-product icon-product">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 12C21 13.2 16.97 18 12 18C7.03 18 3 13.2 3 12C3 10.8 7.03 6 12 6C16.97 6 21 10.8 21 12Z"
                stroke="white"
                stroke-width="1.5"
              />
              <path
                d="M15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12Z"
                stroke="white"
                stroke-width="1.5"
              />
            </svg>
          </div>
          <div class="cart icon-product">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 4H6.5L9 16M9 16C8.46957 16 7.96086 16.2107 7.58579 16.5858C7.21071 16.9609 7 17.4696 7 18C7 18.5304 7.21071 19.0391 7.58579 19.4142C7.96086 19.7893 8.46957 20 9 20C9.53043 20 10.0391 19.7893 10.4142 19.4142C10.7893 19.0391 11 18.5304 11 18C11 17.4696 10.7893 16.9609 10.4142 16.5858C10.0391 16.2107 9.53043 16 9 16H17M17 16C16.4696 16 15.9609 16.2107 15.5858 16.5858C15.2107 16.9609 15 17.4696 15 18C15 18.5304 15.2107 19.0391 15.5858 19.4142C15.9609 19.7893 16.4696 20 17 20C17.5304 20 18.0391 19.7893 18.4142 19.4142C18.7893 19.0391 19 18.5304 19 18C19 17.4696 18.7893 16.9609 18.4142 16.5858C18.0391 16.2107 17.5304 16 17 16ZM8.5 13H17.75L19 7H18M8 7H7.312M13 5V9M11 7H15"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </a>
`;
};

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align:center;">BEST <span style="color:#ad4870ff;"><i>SELLER</i></span></h2>
  </div>
  <div
    data-attribute="body-products"
    class="body-products"
    data-highlight-color="#AD4870"
    data-show-actions="true"
    style="--highlight-color: #AD4870"
  >
    <div data-attribute="gird-products-desktop" class="gird-products-desktop">
      ${products.map(renderProductItem).join('')}
    </div>
    <div data-attribute="grid-products-mobile" class="grid-products-mobile">
      <div class="swiper">
        <div class="swiper-wrapper" data-attribute="swiper-wrapper">
          ${products
            .map(
              item => `<div class="swiper-slide">
              ${renderProductItem(item)}
            </div>`,
            )
            .join('')}
        </div>
      </div>
    </div>
  </div>
  <div data-attribute="wrap-btn-dynamic-primary" class="wrap-btn-dynamic-primary">
    ${btnPrimary}
  </div>
</div>
`;

export default containerFuild(html, css);
